export const menuTranslations = {
    en: {
        // Categories
        categories: 'Categories',
        categoriesDescription: 'Manage your menu categories and organize your items',
        categoryName: 'Category Name',
        categoryNameAr: 'Category Name (Arabic)',
        categorySlug: 'Category Slug',
        categoryIcon: 'Category Icon',
        categoryStatus: 'Status',
        categoryActive: 'Active',
        categoryInactive: 'Inactive',
        addCategory: 'Add Category',
        editCategory: 'Edit Category',
        editCategoryDescription: 'Update category information and settings',
        confirmDeleteCategory: 'Are you sure you want to delete this category?',
        noItemsInCategory: 'No items in this category',
        
        // Items
        manageItems: 'Manage Items',
        addItem: 'Add Item',
        editItem: 'Edit Item',
        editItemDescription: 'Update item information and settings',
        searchItems: 'Search Items',
        allItems: 'All Items',
        noItemsFound: 'No items found',
        getStarted: 'Get started by adding your first item',
        nameEnglish: 'Name (English)',
        nameArabic: 'Name (Arabic)',
        descriptionEnglish: 'Description (English)',
        descriptionArabic: 'Description (Arabic)',
        sortOrder: 'Sort Order',
        category: 'Category',
        selectCategory: 'Select Category',
        itemImage: 'Item Image',
        uploadImage: 'Upload Image',
        imageRequirements: 'PNG, JPG up to 10MB',
        
        // Messages
        confirmDelete: 'Are you sure you want to delete this item?',
        successDelete: 'Item deleted successfully',
        successSave: 'Changes saved successfully',
        errorSave: 'Error saving changes',
        checkFormErrors: 'Please check the form for errors',
        errorLoadingData: 'Error loading data',
        errorSavingChanges: 'Error saving changes',
        errorDeletingItem: 'Error deleting item',
        errorAddingItem: 'Error adding item',
        errorUpdatingItem: 'Error updating item',
    },
    ar: {
        // Categories
        categories: 'الأقسام',
        categoriesDescription: 'إدارة فئات القائمة وتنظيم المنتجات',
        categoryName: 'اسم القسم',
        categoryNameAr: 'اسم القسم (بالعربية)',
        categorySlug: 'رابط القسم',
        categoryIcon: 'أيقونة القسم',
        categoryStatus: 'الحالة',
        categoryActive: 'نشط',
        categoryInactive: 'غير نشط',
        addCategory: 'إضافة قسم',
        editCategory: 'تعديل القسم',
        editCategoryDescription: 'تحديث معلومات وإعدادات القسم',
        confirmDeleteCategory: 'هل أنت متأكد من حذف هذه القسم؟',
        noItemsInCategory: 'لا يوجد أي عناصر في هذا القسم',
        
        // Items
        manageItems: 'إدارة المنتجات',
        addItem: 'إضافة منتج',
        editItem: 'تعديل المنتج',
        editItemDescription: 'تحديث معلومات المنتج وإعداداته',
        searchItems: 'بحث عن المنتجات',
        allItems: 'جميع المنتجات',
        noItemsFound: 'لم يتم العثور على منتجات',
        getStarted: 'ابدأ بإضافة أول منتج',
        nameEnglish: 'الاسم (بالإنجليزية)',
        nameArabic: 'الاسم (بالعربية)',
        descriptionEnglish: 'الوصف (بالإنجليزية)',
        descriptionArabic: 'الوصف (بالعربية)',
        sortOrder: 'ترتيب العرض',
        category: 'القسم',
        selectCategory: 'اختر القسم',
        itemImage: 'صورة المنتج',
        uploadImage: 'رفع صورة',
        imageRequirements: 'PNG, JPG حتى 10MB',
        
        // Messages
        confirmDelete: 'هل أنت متأكد من حذف هذا المنتج؟',
        successDelete: 'تم حذف المنتج بنجاح',
        successSave: 'تم حفظ التغييرات بنجاح',
        errorSave: 'خطأ في حفظ التغييرات',
        checkFormErrors: 'يرجى التحقق من الأخطاء في النموذج',
        errorLoadingData: 'خطأ في تحميل البيانات',
        errorSavingChanges: 'خطأ في حفظ التغييرات',
        errorDeletingItem: 'خطأ في حذف المنتج',
        errorAddingItem: 'خطأ في إضافة المنتج',
        errorUpdatingItem: 'خطأ في تحديث المنتج',
    }
};
